const prefix = 'CORE/FILE_UPLOAD';

export const FILES_ADDED = `${prefix}/FILES_ADDED`;
export const DELETE_FILE = `${prefix}/DELETE_FILE`;
export const EMPTY_STATE = `${prefix}/EMPTY_STATE`;
